import RiskPopup from './RiskPopup';

export default RiskPopup;
